import { Card, CardContent } from "@mui/material";

export default function PerformanceLeaderboard({ data = [] }) {
  if (!data.length)
    return <div className="text-center text-muted-foreground py-4">No leaderboard data available</div>;

  // Optional: sort by leads_closed descending
  const sorted = [...data].sort((a, b) => b.leads_closed - a.leads_closed);

  return (
    <Card className="bg-background shadow-md mt-6">
      <CardContent className="p-4">
        <h3 className="text-lg font-semibold mb-3">Top Performers</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm border-collapse">
            <thead>
              <tr className="text-left border-b border-border">
                <th className="py-2 px-3">Rank</th>
                <th className="py-2 px-3">User</th>
                <th className="py-2 px-3">Leads Added</th>
                <th className="py-2 px-3">Leads Closed</th>
                <th className="py-2 px-3">Conversion</th>
              </tr>
            </thead>
            <tbody>
              {sorted.map((rep, i) => (
                <tr
                  key={rep.user_id}
                  className={`border-b border-border ${
                    i === 0 ? "bg-primary/10 font-semibold" : ""
                  }`}
                >
                  <td className="py-2 px-3">{i + 1}</td>
                  <td className="py-2 px-3">{rep.username}</td>
                  <td className="py-2 px-3">{rep.leads_added}</td>
                  <td className="py-2 px-3">{rep.leads_closed}</td>
                  <td className="py-2 px-3">{rep.conversion_rate}%</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
